import script from "./ESwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./ESwitch.vue?vue&type=script&lang=ts&setup=true"

import "./ESwitch.vue?vue&type=style&index=0&id=09691180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09691180"]])

export default __exports__